export const formatPeriodUnit = (duration, unit, withHyphen = true) => {
  const formattedUnit = unit.endsWith("S") ? unit.slice(0, -1) : unit;

  return `${duration}${withHyphen ? '-' : ' '}${formattedUnit.charAt(0).toUpperCase()}${formattedUnit
    .slice(1)
    .toLowerCase()}`;
};
